import { Route, Routes } from 'react-router-dom';
import Reports from '../components/Reports/Reports';
import React from 'react';
import CreateReportSchedule from '../components/Reports/ReportSchedule/EditReportSchedule/EditCreateReportSchedule';

export function ReportRoutes() {
  return (
    <Routes>
      <Route path="settings" element={<Reports />} />
      <Route path="settings/create" element={<CreateReportSchedule />} />
      <Route path="*" element={<Reports />} />
    </Routes>
  );
}
